<template>
    <EditModelLayout
        :indexRoute="$route('admin::time-entries.index')"
        :updateRoute="$route('admin::time-entries.update', { time_entry: timeEntry.id })"
        :modelNameSingular="__('admin::time_entries.time_entry')"
        :modelNamePlural="__('admin::time_entries.time_entries')"
        :form="form"
        :name="$date(timeEntry.date, 'll')"
    >

        <FormGroup :label="__('admin::labels.user')">
            <Input disabled :value="timeEntry.user?.name" />
        </FormGroup>

        <FormGroup :label="__('admin::labels.date')">
            <Input disabled :value="$date(timeEntry.date, 'll')" />
        </FormGroup>

        <FormGroup :label="__('admin::labels.checked_in_at')" :error="errors.checked_in_at">
            <Datepicker mode="time" name="checked_in_at" :has-error="exists(errors.checked_in_at)" v-model="form.checked_in_at" :required="true" />
        </FormGroup>

        <FormGroup :label="__('admin::labels.checked_out_at')" :error="errors.checked_out_at">
            <Datepicker mode="time" name="checked_out_at" :has-error="exists(errors.checked_out_at)" v-model="form.checked_out_at" :required="false" />
        </FormGroup>

        <FormGroup :label="__('admin::labels.notes')" :error="errors.notes">
            <Textarea name="notes" :has-error="exists(errors.notes)" v-model="form.notes" :required="false" />
        </FormGroup>

    </EditModelLayout>
</template>

<script>
export default {
    props: {
        errors: Object,
        timeEntry: Object,
    },
    data() {
        return {
            form: this.$inertia.form({
                checked_in_at: this.$date(this.timeEntry.checked_in_at, 'HH:mm:ss'),
                checked_out_at: this.$date(this.timeEntry.checked_out_at, 'HH:mm:ss'),
                notes: this.timeEntry.notes,
            })
        }
    },
}
</script>
